import { render, staticRenderFns } from "./hotel-image.vue?vue&type=template&id=f6162312"
import script from "./hotel-image.vue?vue&type=script&lang=js"
export * from "./hotel-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports